"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export let QuoteLauncherActionType = /*#__PURE__*/function (QuoteLauncherActionType) {
  QuoteLauncherActionType[QuoteLauncherActionType["RESET"] = 0] = "RESET";
  QuoteLauncherActionType[QuoteLauncherActionType["MAKE_CHANGED"] = 1] = "MAKE_CHANGED";
  QuoteLauncherActionType[QuoteLauncherActionType["MODEL_CHANGED"] = 2] = "MODEL_CHANGED";
  QuoteLauncherActionType[QuoteLauncherActionType["LOCATION_CHANGED"] = 3] = "LOCATION_CHANGED";
  return QuoteLauncherActionType;
}({});
export const quoteLauncherReducer = (state, action) => {
  switch (action.type) {
    case QuoteLauncherActionType.RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        make: null,
        model: null,
        location: null,
        linkUrl: null
      });
    case QuoteLauncherActionType.MAKE_CHANGED:
      return _objectSpread(_objectSpread({}, state), {}, {
        make: action.value ? _objectSpread({}, action.value) : null,
        model: null,
        linkUrl: null
      });
    case QuoteLauncherActionType.MODEL_CHANGED:
      return _objectSpread(_objectSpread({}, state), {}, {
        model: action.value ? _objectSpread({}, action.value) : null
      });
    case QuoteLauncherActionType.LOCATION_CHANGED:
      return _objectSpread(_objectSpread({}, state), {}, {
        location: action.value ? _objectSpread({}, action.value) : null
      });
    default:
      return state;
  }
};